import { useEffect, useState } from 'react';

const STORAGE_KEY = 'gdpr_consent';
const CONSENT_VERSION = 1;

const readConsent = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (parsed.version !== CONSENT_VERSION) return null;
        return parsed;
    } catch {
        return null;
    }
};

const writeConsent = (status) => {
    const record = {
        version: CONSENT_VERSION,
        status,
        timestamp: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    window.dispatchEvent(new CustomEvent('gdpr-consent-change', { detail: record }));
    return record;
};

export const useCookieConsent = () => {
    const [consent, setConsent] = useState(readConsent);

    useEffect(() => {
        const onChange = (e) => setConsent(e.detail);
        window.addEventListener('gdpr-consent-change', onChange);
        return () => window.removeEventListener('gdpr-consent-change', onChange);
    }, []);

    return {
        consent,
        status: consent?.status || 'pending',
        accept: () => setConsent(writeConsent('granted')),
        reject: () => setConsent(writeConsent('denied')),
    };
};

export default useCookieConsent;
